import { render, staticRenderFns } from "./subject.vue?vue&type=template&id=4da05590&scoped=true"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"
import style0 from "./subject.vue?vue&type=style&index=0&id=4da05590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da05590",
  null
  
)

export default component.exports